import { React, useRef, useEffect } from "react"
import PropTypes from 'prop-types'
import ArrowRight from '../../common/images-new/arrow-right-black-icon.svg'
import ShowcaseLink from "./ShowcaseLink";
import LockGray from '../../common/images-new/lock-gray-icon.svg'
import PublicGreen from '../../common/images-new/public-green-icon.svg'
import { MdOutlinePublic, MdArrowRight, MdArrowLeft } from 'react-icons/md';
import { SideBarActiveCount, SideBarNormalCount, } from "../../pages/Theme";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import { PublishIcon } from "../../pages/Theme";
let wheel = false;

const PublicShowcaseTab = ({ data, selectedId, setPage }) => {
    const ref = useRef()
    const scroll = (scrollOffset) => {
        ref.current.scrollLeft += scrollOffset;
    }

    useEffect(() => {
        const interval = setInterval(() => {
            handleCheckScroll();
        }, 1)
        return () => {
            clearInterval(interval);
        }
    }, []);

    const handleCheckScroll = () => {
        if (wheel == true) {
            document && document.addEventListener("wheel", preventDefault, { passive: false });
        } else {
            document && document.removeEventListener("wheel", preventDefault, false);
        }
    };

    const handleScroll = (event) => {
        const scrollAmount = event.deltaY || event.deltaX;
        ref.current.scrollLeft += scrollAmount;
        event.preventDefault();
    }

    const preventDefault = (ev) => {
        if (ev.preventDefault) {
            ev.preventDefault();
        }
        ev.returnValue = false;
    };

    const handleMouseEnter = () => {
        wheel = true;
    }

    const handleMouseLeave = () => {
        wheel = false;
    }
    return (<>
        {/*  <div className="flex flex-row flex-1 mx-4 md:mx-0"
             onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave}
         > */}
        {/* <img className="hover:opacity-50 cursor-pointer transform -rotate-180 -mt-6" 
                src={ArrowRight} alt="arrow right" onClick={() => scroll(-100)} 
            /> */}
        {/* <ActiveIconColor>
                <MdArrowLeft className="ml-3 hover:opacity-90 cursor-pointer transform w-8 h-8" onClick={() => scroll(-100)} />
            </ActiveIconColor> */}

        {/* <div className="flex flex-1 flex-row w-60 mx-2 xl:mr-2 overflow-x-auto
                            items-center bg-transparent whitespace-nowrap no-scrollbar"
                ref={ref}
                onWheel={(event) => handleScroll(event)}
                
            > */}
        <Tabs
            value={selectedId}
            // onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            ref={ref}
            onWheel={(event) => handleScroll(event)}
            sx={{

                '.MuiTabs-scrollButtons.Mui-disabled': {
                    opacity: 0,
                    display: 'none !important',  // Hide the button when disabled
                },
            }}
        >
            {
                data &&
                // data.map((showcase, index) => (
                // <div key={index} className="flex flex-col">
                //     <ShowCaseDiv className={"flex flex-row items-center mb-0 hover:opacity-80 cursor-pointer mx-5"}
                //         onClick={() => setPage(index)}
                //     >
                //         <p className="font-semibold whitespace-nowrap text-sm mr-2">{showcase.name}</p>
                //         <p className="font-semibold text-sm">({showcase.posts.length})</p>
                //     </ShowCaseDiv>
                //     {index === selectedId ? <ShowCaseDiv className={'mt-6 border-b-4 mr-2 transition ease-linear duration-300'} />
                //         : <div className="mt-6" />
                //     }

                // </div>
                data.map((tab, index) => (
                    <Tab key={index} label={<span className="flex items-center space-x-2">
                        <span>{tab.name}</span>
                        {selectedId === index ? (
                            <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs tabCount">
                                {tab.posts.length}
                            </SideBarActiveCount>
                        ) : (
                            <SideBarNormalCount className="inline-flex flex-shrink-0 items-center justify-center p-1 text-center text-xs tabCount">
                                {tab.posts.length}
                            </SideBarNormalCount>
                        )}
                    </span>}
                        // icon={
                        //     <PublishIcon className='z-50'><MdOutlinePublic className="w-5 h-5 primaryIcon" />
                        //     </PublishIcon>}
                        onClick={() => setPage(index)}
                        value={index}
                        iconPosition="start" sx={{
                            minHeight: 48,
                            '.MuiTabs-scrollButtons.Mui-disabled': {
                                opacity: 0,
                                display: 'none !important',  // Hide the button when disabled
                            },
                        }} />
                ))}

            {/* ))} */}
            {/* </div> */}
        </Tabs>

        {/* <img className="hover:opacity-50 cursor-pointer -mt-6" 
                src={ArrowRight} alt="arrow right" onClick={() => scroll(100)} 
            /> */}
        {/* <ActiveIconColor>
                <MdArrowRight className="hover:opacity-50 cursor-pointer w-8 h-8" onClick={() => scroll(100)} />
            </ActiveIconColor> */}
    </>

    )
}

PublicShowcaseTab.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
            id: PropTypes.number,
        }),
    ),
    page: PropTypes.string,
    setPage: PropTypes.func,
}

export default PublicShowcaseTab

// import { React, useRef, useEffect } from "react"
// import PropTypes from 'prop-types'
// import ArrowRight from '../../common/images-new/arrow-right-black-icon.svg'
// import ShowcaseLink from "./ShowcaseLink";
// import LockGray from '../../common/images-new/lock-gray-icon.svg'
// import PublicGreen from '../../common/images-new/public-green-icon.svg'
// import { MdOutlinePublic, MdArrowRight, MdArrowLeft } from 'react-icons/md';
// import { ActiveIconColor, ButtonCommonTop, TextGray, TextGreen, ShowCaseDiv } from "../../pages/Theme";

// let wheel = false;

// const PublicShowcaseTab = ({ data, selectedId, setPage }) => {
//     const ref = useRef()
//     const scroll = (scrollOffset) => {
//         ref.current.scrollLeft += scrollOffset;
//     }

//     useEffect(() => {
//         const interval = setInterval(() => {
//             handleCheckScroll();
//         }, 1)
//         return () => {
//             clearInterval(interval);
//         }
//     }, []);

//     const handleCheckScroll = () => {
//         if (wheel == true) {
//             document && document.addEventListener("wheel", preventDefault, { passive: false });
//         } else {
//             document && document.removeEventListener("wheel", preventDefault, false);
//         }
//     };

//     const handleScroll = (event) => {
//         const scrollAmount = event.deltaY || event.deltaX;
//         ref.current.scrollLeft += scrollAmount;
//         event.preventDefault();
//     }

//     const preventDefault = (ev) => {
//         if (ev.preventDefault) {
//             ev.preventDefault();
//         }
//         ev.returnValue = false;
//     };

//     const handleMouseEnter = () => {
//         wheel = true;
//     }

//     const handleMouseLeave = () => {
//         wheel = false;
//     }

//     return (
//         <div className="flex flex-row flex-1 mx-4 md:mx-0"
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//         >
//             {/* <img className="hover:opacity-50 cursor-pointer transform -rotate-180 -mt-6"
//                 src={ArrowRight} alt="arrow right" onClick={() => scroll(-100)}
//             /> */}
//             <ActiveIconColor>
//                 <MdArrowLeft className="ml-3 hover:opacity-90 cursor-pointer transform w-8 h-8" onClick={() => scroll(-100)} />
//             </ActiveIconColor>

//             <div className="flex flex-1 flex-row w-60 mx-2 xl:mr-2 overflow-x-auto
//                             items-center bg-transparent whitespace-nowrap no-scrollbar"
//                 ref={ref}
//                 onWheel={(event) => handleScroll(event)}
//             >
//                 {
//                     data &&
//                     data.map((showcase, index) => (
//                         <div key={index} className="flex flex-col">
//                             <ShowCaseDiv className={"flex flex-row items-center mb-0 hover:opacity-80 cursor-pointer mx-5"}
//                                 onClick={() => setPage(index)}
//                             >
//                                 <p className="font-semibold whitespace-nowrap text-sm mr-2">{showcase.name}</p>
//                                 <p className="font-semibold text-sm">({showcase.posts.length})</p>
//                             </ShowCaseDiv>
//                             {index === selectedId ? <ShowCaseDiv className={'mt-6 border-b-4 mr-2 transition ease-linear duration-300'} />
//                                 : <div className="mt-6" />
//                             }

//                         </div>
//                     ))}
//             </div>

//             {/* <img className="hover:opacity-50 cursor-pointer -mt-6"
//                 src={ArrowRight} alt="arrow right" onClick={() => scroll(100)}
//             /> */}
//             <ActiveIconColor>
//                 <MdArrowRight className="hover:opacity-50 cursor-pointer w-8 h-8" onClick={() => scroll(100)} />
//             </ActiveIconColor>
//         </div>

//     )
// }

// PublicShowcaseTab.propTypes = {
//     tabs: PropTypes.arrayOf(
//         PropTypes.shape({
//             text: PropTypes.string,
//             id: PropTypes.number,
//         }),
//     ),
//     page: PropTypes.string,
//     setPage: PropTypes.func,
// }

// export default PublicShowcaseTab
